export const CUSTOMER_CREDIT_BALANCE_ROUTE = 'credit-balance';

const DECIMAL_STRING = /^(?:0|[1-9]\d*)(?:\.\d+)?$/;

export const isInvariantDecimalString = (value: unknown): value is string =>
  typeof value === 'string' && DECIMAL_STRING.test(value);
